import { PolicyInfo, PolicyInfoApprovalType } from 'obt-common/types/api/v1/obt/common/policy_info';
import { useTranslation } from 'react-i18next';
import CheckoutApprovalMessage from 'src/v2-components/shared/CheckoutApprovalMessage';
import { HardApprovalContainer } from './styles';

interface IApprovalMessageContainer {
  policyInfos: PolicyInfo[];
  isVoidable: boolean;
}

function ApprovalMessageContainer({ policyInfos, isVoidable }: IApprovalMessageContainer) {
  const { t: tt } = useTranslation('WEB');
  let hardApprovalRequired = false;
  policyInfos.forEach((policyInfo) => {
    if (policyInfo?.approvalType === PolicyInfoApprovalType.HARD_APPROVAL) {
      hardApprovalRequired = true;
    }
  });

  let softApprovalRequired = false;
  policyInfos.forEach((policyInfo) => {
    if (policyInfo?.approvalType === PolicyInfoApprovalType.SOFT_APPROVAL) {
      softApprovalRequired = true;
    }
  });

  let message = '';
  const showHardApprovalMessage = hardApprovalRequired;
  if (showHardApprovalMessage) {
    message = isVoidable
      ? tt("This booking requires approval. If approval isn't received on time this booking will be voided.")
      : tt(
          'This booking requires approval but cannot be refunded or exchanged. If approval is not given it will result in a loss of funds.',
        );
  }

  const showSoftApprovalMessage = !showHardApprovalMessage && softApprovalRequired;
  if (showSoftApprovalMessage) {
    message = tt(
      'This booking is subject to an approval process. If your booking is denied you will receive an email notification with more information.',
    );
  }
  if (showHardApprovalMessage || showSoftApprovalMessage) {
    return (
      <HardApprovalContainer>
        <CheckoutApprovalMessage
          showApprovalMessage={showHardApprovalMessage || showSoftApprovalMessage}
          message={message}
        />
      </HardApprovalContainer>
    );
  }

  return null;
}
export default ApprovalMessageContainer;
